module.exports = __webpack_public_path__ + "media/img/icons/chevron-left-circle-ad7233e331ba9b669b6cc59262c528ee.png";